import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = get(state, 'innovationByDesign.year');
  const img = `https://a.fastcompany.net/multisite_files/fastcompany/imagecache/w/500/h/400/scale/ibd/ibd-${year}-logo-share.png`;

  // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
  let description = `Check out the ${year} Innovation by Design Awards.`;
  if (parseInt(year, 10) === 2017) {
    description =
      "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " +
      'best products, services, interfaces, and ideas.';
  }

  return baseSeoUtil({
    site,
    siteConf,
    title: `Innovation by Design Awards ${year}`,
    url: `https://www.fastcompany.com/innovation-by-design/${year}`,
    description,
    image: img,
    articleSection: 'Innovation By Design Awards',
    config: state.config
  });
}
